import React, { useEffect } from 'react';
import * as leaflet from 'leaflet';
import { Marker, useMap, useMapEvents } from 'react-leaflet';
import imagePin from '@assets/img/image-pin.png';
import { hasOccurence, hasOccurenceViewed } from '@utils/occurrence';
import { MapPropsInterface } from '../MapContainerType';
import Popup from './Popup';

function Markers({ markers }: MapPropsInterface) {
  const map = useMap();
  const classActiveMarker = 'active-marker';

  useMapEvents({
    click: () => {
      window.dispatchEvent(new CustomEvent('clickMapInner'));
    },
  });

  function renderMarkers(markersToRender: MapPropsInterface['markers']) {
    const latsLonsRendered: [[number, number]] = [[0, 0]];
    return markersToRender.map((pin, index) => {
      const pinTemp = { ...pin };
      const { occurrence } = pinTemp;
      const hasOccurenceTemp =
        hasOccurence(occurrence) && !hasOccurenceViewed(occurrence);
      const urlAvatarTrucker = pinTemp.avatar || imagePin;
      let containerClassName = 'container-icon-avatar';
      const alertIcon =
        // eslint-disable-next-line max-len
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 1C11.566 1 11.1404 1.11978 10.7701 1.34614C10.3998 1.5725 10.0991 1.89666 9.90123 2.28293L9.90119 2.28292L9.89774 2.28981L1.25226 19.5808L1.25163 19.582C1.07117 19.9406 0.985262 20.3395 1.00207 20.7407C1.01889 21.1424 1.1381 21.533 1.34839 21.8756C1.55867 22.2182 1.85304 22.5013 2.20354 22.6981C2.55404 22.8949 2.94905 22.9989 3.35102 23.0001H3.35341H20.6465H20.6489C21.0509 22.9989 21.4459 22.8949 21.7964 22.6981C22.1469 22.5013 22.4412 22.2182 22.6516 21.8756C22.8619 21.533 22.9811 21.1424 22.9979 20.7407C23.0148 20.3395 22.9288 19.9405 22.7483 19.5819L22.7477 19.5808L14.1022 2.28981L14.1023 2.28979L14.0988 2.28293C13.9009 1.89666 13.6002 1.5725 13.2299 1.34614C12.8596 1.11978 12.434 1 12 1ZM11.9999 7.87029C12.5426 7.87029 12.9825 8.3102 12.9825 8.85286V13.5692C12.9825 14.1118 12.5426 14.5517 11.9999 14.5517C11.4573 14.5517 11.0174 14.1118 11.0174 13.5692V8.85286C11.0174 8.3102 11.4573 7.87029 11.9999 7.87029ZM11.9999 19.8576C12.8682 19.8576 13.5721 19.1538 13.5721 18.2855C13.5721 17.4173 12.8682 16.7134 11.9999 16.7134C11.1317 16.7134 10.4278 17.4173 10.4278 18.2855C10.4278 19.1538 11.1317 19.8576 11.9999 19.8576Z" fill="currentColor"/></svg>';

      if (hasOccurenceTemp) {
        containerClassName += ' has--occurence';
      }

      if (latsLonsRendered.length) {
        /*
            Enquanto encontrar motoristas com a mesma localização
            soma 0.004 na lat para dar a sensação de sobreposição
         */
        while (
          latsLonsRendered.find(
            (latLonRendered) => latLonRendered[0] === pinTemp.coordinates[0],
          )
        ) {
          pinTemp.coordinates = [
            pinTemp.coordinates[0] + 0.004,
            pinTemp.coordinates[1],
          ];
        }
      }

      latsLonsRendered.push(pinTemp.coordinates);

      return (
        <Marker
          position={leaflet.latLng(pinTemp.coordinates)}
          icon={
            new leaflet.DivIcon({
              iconUrl: pinTemp.avatar || imagePin,
              iconSize: [30, 30],
              iconAnchor: [14, 36],
              className: containerClassName,
              html: `<div class="wrapper-icon" id="marker-journeyId-${pinTemp.journeyId}"><img src="${urlAvatarTrucker}" /></div><div class="alert-occurence">${alertIcon}</div>`,
            })
          }
          key={`marker-${pinTemp.name}-${pinTemp.journeyId}`}
          eventHandlers={{
            click: () =>
              window.dispatchEvent(
                new CustomEvent('togglePopupMarker', {
                  detail: pinTemp.journeyId,
                }),
              ),
            popupopen: (e) => {
              const marker = e.sourceTarget.getElement();

              setTimeout(() => {
                if (marker) {
                  marker.classList.add(classActiveMarker);
                }
              }, 50);
            },
            popupclose: (e) => {
              const marker = e.sourceTarget.getElement();

              if (marker) {
                marker.classList.remove(classActiveMarker);
              }

              window.dispatchEvent(
                new CustomEvent('mapOccurrenceRemove', {
                  detail: {
                    journeyId: pinTemp.journeyId,
                  },
                }),
              );
            },
          }}
          zIndexOffset={(index + 1) * 100}
        >
          <Popup {...pinTemp} />
        </Marker>
      );
    });
  }

  useEffect(() => {
    setTimeout(() => {
      map.invalidateSize();
    }, 500);
  }, []);

  return <>{renderMarkers(markers)}</>;
}

export default Markers;
